import React from 'react';
import './Header.css';
import logo from '../images/logo.svg'

const Header = () => {
    return (
        <div className='header-container'>
            <img src={logo} alt="" />
            <div className='menu-container'>
                <a href="/">Home</a>
                <a href="/">Orders</a>
                <a href="/">Cart</a>
                <a href="/">About</a>
            </div>
        </div>
    );
};

export default Header;